export interface IdName {
  id: string;
  name: string;
}

export interface CookieOptions {
  path?: string;
  domain?: string;
  maxAge?: number;
  expires?: number | Date;
  secure?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
  httpOnly?: boolean;
}

export type ErrorType = 'validation' | 'network' | 'api' | 'unknown';

/**
 * URL filter key (under `f.` prefix): opaque `DeploymentDelta.id` for the
 * Releases page `where.deploymentId` filter (fly-service#1241 / #1242).
 * Preferred over {@link FILTER_PROMPT_DEPLOYMENT_KEY}; clients must treat the
 * value as an opaque token.
 *
 * Preserved alongside `f.prompt_query` / `f.prompt_values` when descriptor
 * filters sync the URL (`useTableFilters`).
 */
export const FILTER_PROMPT_DEPLOYMENT_ID_KEY = 'prompt_deployment_id';

/**
 * URL filter key (under `f.` prefix from `constants/common.ts`):
 * encodes the deployment wave triple for the Releases page `where.deployment`
 * filter (PR fly-service#1164). Value format:
 * **Preferred wire format:** three `encodeURIComponent` segments joined by
 * `FILTER_PROMPT_DEPLOYMENT_SEGMENT_JOINER` (`::`), so workflow names may
 * contain `|` without breaking parsing. Legacy unencoded
 * `env|workflow|number` (single `|`) is still accepted when reading URLs.
 * Superseded for new deep links by {@link FILTER_PROMPT_DEPLOYMENT_ID_KEY}.
 *
 * Preserved alongside `f.prompt_query` / `f.prompt_values` when descriptor
 * filters sync the URL (`useTableFilters`).
 */
export const FILTER_PROMPT_DEPLOYMENT_KEY = 'prompt_deployment';

/** Legacy delimiter (unencoded triple). Prefer `FILTER_PROMPT_DEPLOYMENT_SEGMENT_JOINER` when writing. */
export const FILTER_PROMPT_DEPLOYMENT_VALUE_DELIMITER = '|' as const;

/** Joiner between URL-encoded segments in `f.prompt_deployment` (cannot appear inside `encodeURIComponent` output). */
export const FILTER_PROMPT_DEPLOYMENT_SEGMENT_JOINER = '::' as const;
